// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P2Y6","toggleWrap":"styles_toggleWrap__1rTwh","content":"styles_content__3_p8Q","selectAreaCode":"styles_selectAreaCode__2omCd"};